import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OldAccountService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  OldAccountCreateDto,
  OldAccountDto,
  OldAccountExcelDownloadDto,
  OldAccountUpdateDto,
} from '../proxy/controlling/dtos/old-account';
import { OLDACCOUNT_CONFIG, OLDACCOUNT_FIELDS } from './old-account.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-old-account',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, OldAccountService, ConfirmationService],
  templateUrl: './old-account.html',
  styleUrl: './old-account.scss',
})
export class OldAccount extends BaseHierarchicalCrudComponent<
  OldAccountDto,
  OldAccountCreateDto,
  OldAccountUpdateDto,
  OldAccountExcelDownloadDto
> {
  service = inject(OldAccountService);
  config = OLDACCOUNT_CONFIG;
  fields = OLDACCOUNT_FIELDS;

  protected prepareUpdateDto(data: any, selected: OldAccountDto): OldAccountUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OldAccount';
  }
}
